import React, { useState, useEffect } from 'react'
import { Box, TextInput, Flex, Group, Button } from '@mantine/core'
import { DateInput } from '@mantine/dates'
import { validation } from '../../../../../plugins/validation'
import { useSelector, useDispatch } from 'react-redux'
import { updateOrder } from '../../../../../services/orders'
import { useParams } from 'react-router-dom'
import { getOrderDetail } from '../../../../../store/orderDetail'
import { notificationSuccess, notificationError } from '../../../../ui/Notifications'
import dayjs from 'dayjs'

const defaultVal = {
  order_code: '',
  order_date: ''
}

const formValidation = {
  order_code: {
    isError: false,
    message: ''
  },
  order_date: {
    isError: false,
    message: ''
  },
}

const FormAdjustOrderCode = ({ onCloseForm }) => {
  const { summary } = useSelector(state => state.order_detail)
  const dispatch = useDispatch()
  const params = useParams()
  const orderId = params.order_id
  const [formData, setFormData] = useState(defaultVal)
  const [validationForm, setValidationForm] = useState(formValidation)
  const [loadingForm, setLoadingForm] = useState(false)

  const submitUpdateOrder = async (form) => {
    setLoadingForm(true)
    setValidationForm(formValidation)
    const isError = validation(form, setValidationForm)
    if (isError) {
      setLoadingForm(false)
      return
    }
    const payload = {
      order_code: form.order_code,
      order_date: dayjs(form.order_date).format('YYYY-MM-DD')
    }
    try {
      const response = await updateOrder(orderId, payload)
      if (response.success) {
        onCloseForm()
        dispatch(getOrderDetail(orderId))
        notificationSuccess('Update Order Successfully', 'This data has been updated')
      }
    } catch (error) {
      console.log(error)
      const errorMessage = error.response.data.message
      notificationError('Update Order Error', `${errorMessage ? errorMessage : 'Please recheck your form'}`)
    } finally {
      setLoadingForm(false)
    }
  }

  useEffect(() => {
    if (summary) {
      handleSetForm(summary)
    }
  }, [summary])

  const handleSetForm = (value) => {
    const dataDetail = {
      order_code: value.orderCode,
      order_date: new Date(value.orderDate)
    }
    setFormData(dataDetail)
  }

  const handleChangeForm = (name, val) => {
    setFormData((oldVal) => ({ ...oldVal, [name]: val}))
  }

  return (
    <Box>
      <Box mb='md'>
        <TextInput
          name='order_code'
          value={formData.order_code}
          label='Order Code'
          placeholder='Input order code order'
          error={validationForm.order_code.isError ? `${validationForm.order_code.message}` : ''}
          onChange={(val) => handleChangeForm('order_code', val.target.value)}
          withAsterisk
          size='xs'
        />
      </Box>
      <Box mb='md'>
        <DateInput
          name='order_date'
          value={formData.order_date}
          label='Order Date'
          placeholder='Input order code order'
          valueFormat="DD/MM/YYYY"
          error={validationForm.order_date.isError ? `${validationForm.order_date.message}` : ''}
          onChange={(val) => handleChangeForm('order_date', val)}
          withAsterisk
          size='xs'
          clearable
        />
      </Box>
      <Box mt={20}>
        <Flex justify='flex-end'>
          <Group>
            <Button size='xs' variant="outline" onClick={onCloseForm}>Close</Button>
            <Button size='xs' loading={loadingForm} variant="filled" onClick={() => submitUpdateOrder(formData)}>{summary ? 'Update' : 'Create'}</Button>
          </Group>
        </Flex>
      </Box>
    </Box>
  )
}

export default FormAdjustOrderCode